import { render, staticRenderFns } from "./AchievementsModal.vue?vue&type=template&id=2e3ef3d8&"
import script from "./AchievementsModal.vue?vue&type=script&lang=js&"
export * from "./AchievementsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports